import {AgencyRepository} from "../../../repositories/AgencyRepository.ts";

export class DeleteAgencyUseCase {
    constructor(private readonly agencyRepository: AgencyRepository) {

    }
    async execute(agencyId: string): Promise<void> {
        return this.agencyRepository.deleteAgency(agencyId);
    }
}
